module.exports = __webpack_public_path__ + "static/media/bg_eco.07ff552b.png";